// @ts-nocheck

import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { ButtonUI, useDidUpdate } from 'sonata-react-components';

import { ReportingShareReportModalContext } from '../ReportingShareReportModalContext';
import { ReportingShareReportLinkStyle } from './reportingShareReportLink.style';

function ReportingShareReportLink({ passwordCopyToClipboardCallback }) {
  const { formatMessage } = useIntl();

  const { currentSharedReportLink, passwordLinkEnabled } = useContext(ReportingShareReportModalContext);

  return (
    <ReportingShareReportLinkStyle className={`sharedReportLink ${passwordLinkEnabled ? '' : 'off'}`}>
      <label className="sharedReportLink__copyLinkLabel">{`${currentSharedReportLink}`}</label>
      <ButtonUI
        className="sharedReportLink__copyLink"
        disabled={!passwordLinkEnabled}
        icon="fal fa-copy"
        id="share_report_modal_link_button"
        onClick={passwordCopyToClipboardCallback}
        shape="squareRounded"
        size="small"
        text={formatMessage({
          defaultMessage: 'Copy link',
          id: 'reporting.shareReportModal.buttonText'
        })}
        type="secondary"
        visible
      />
    </ReportingShareReportLinkStyle>
  );
}

ReportingShareReportLink.propTypes = {
  passwordCopyToClipboardCallback: PropTypes.func.isRequired
};

export default React.memo(ReportingShareReportLink);
